
import { SearchableDropdown } from 'components/SearchableDropdown';
import { DEFAULT_PAGE_SIZE } from './state/constants';
import * as React from 'react';
import { EngineCategory } from './state/types';


interface Props {
    categories?: EngineCategory[]
    page: number
    limit: number
    isLoadingCategories: boolean
    lastPageSize: number
    query: string
    selectedCategory?: EngineCategory

    onQueryChange: (query: string) => void
    loadCategories: () => void
    onCategorySelected: (category: EngineCategory) => void
}

const CategorySelect = (props: Props) => {
    const canLoadMore = React.useMemo(() => {
        return props.lastPageSize ? props.lastPageSize === DEFAULT_PAGE_SIZE : true
    }, [props.lastPageSize])

    const isLoadingInitialCategories = React.useMemo(() => {
        return props.page === 0 && props.isLoadingCategories
    }, [props.page, props.isLoadingCategories])

    // const rootProps = useSelector((rootState: RootState) => {
    //     const isLoadingMoreDealers = serviceLoading(rootState, [GET_DEALER_API_REQUEST]);
    //     const isLoadingInitialDealers = rootState.dealers.dealer.page === 0 && isLoadingMoreDealers
    //     
    //     return {
    //         dealers: rootState.dealers.dealer.dealers,
    //         page: rootState.dealers.dealer.page,
    //         limit: rootState.dealers.dealer.limit,
    //         isLoadingMoreDealers,
    //         isLoadingInitialDealers,
    //         canLoadMore,
    //         query: rootState.dealers.dealer.query,
    //         selectedDealer: rootState.dealers.dealer.selectedDealer
    //     }
    // }, shallowEqual);

    // React.useEffect(() => {
    //     dispatch(getDealerAPI(rootProps.page, rootProps.limit, rootProps.query))
    // }, [rootProps.page, rootProps.query])


    const suggestItems = React.useMemo(() => {
        if (props.categories) {
            const onlyInterestedCategories = props.categories
                .filter(o => o.name.toLocaleLowerCase().includes(props.query.toLocaleLowerCase())
                    || o.id.toLocaleLowerCase().includes(props.query.toLocaleLowerCase()));
            return onlyInterestedCategories.map(category => ({
                id: category.id,
                displayName: `${category.name}`
            }))
        }
        return undefined;

    }, [props.categories, props.query])

    const selectedOption = React.useMemo(() => {
        if (props.selectedCategory) {
            return {
                id: props.selectedCategory.id,
                displayName: props.selectedCategory.name
            }
        }
        return undefined
    }, [props.selectedCategory])

    if (!props.categories) {
        return null
    }

    return (
        <SearchableDropdown
            selectedOption={selectedOption}
            value={props.query}
            options={suggestItems}
            isLoading={isLoadingInitialCategories}
            canLoadMoreOptions={canLoadMore}
            emptyText={getEmptyText()}
            placeholder={"New Category"}
            readonly={false}
            onValueChange={(v) => onSearchQueryChange(v)}
            onOptionSelected={onSelectedItem}
            onDrawerDismissed={onDrawerDismissed}
            onLoadMoreOptions={loadMoreOptions}
        />
    )

    function onSearchQueryChange(query) {
        props.onQueryChange(query);
    }

    function loadMoreOptions() {
        props.loadCategories()
    }

    function getEmptyText() {
        if (isLoadingInitialCategories) {
            if (props.query === "") {
                return "Loading..."
            } else {
                return `Searching "${props.query}"`
            }
        } else {
            if (props.query !== "") {
                return `No Categories found for "${props.query}"`
            } else {
                return `No Categories found`
            }
        }
    }

    function onDrawerDismissed() {
        props.onQueryChange("")
    }

    function onSelectedItem(item) {
        const allCategories = props.categories ?? []
        const category = allCategories.find(d => d.id === item.id)
        if (category) {
            props.onCategorySelected(category)
        }
    }
}

export default CategorySelect;
